import React, { Component, Fragment } from 'react';

import NavigatoinBar from '../../components/navbar/NavigationBar'
import Footer from '../../components/footer/Footer'
import MainPageHero from './main-page-hero/MainPageHero'
import MainPageProject from './main-page-project/MainPageProject'
import MainPageEtsy from './main-page-etsy/MainPageEtsy'
import MainPagePersonalization from './main-page-personalization/MainPagePersonalization'
import MainPagePosts from './main-page-posts/MainPagePosts'
import styles from './MainPage.css'
import grid from '../../styles/grid.css'
import fonts from '../../styles/fonts.css'

// main page images
import alexaImage from '../../assets/img/main-page/alexa.png'
import truckerpathImage from '../../assets/img/main-page/truckerpath.png'
import photolabImage from '../../assets/img/main-page/photolab.png'
import photolabMobileImage from '../../assets/img/main-page/photolab_mobile.png'

class MainPage extends Component {
    state = {
        projects: {
            alexa: {
                direction: "ltr",
                title: "Amazon Alexa",
                description: "<p>Key developer on Alexa Hands-Free - always-on, on-device speech recognition, built with Qualcomm and Motorola silicon teams to run the audio ML engine at the edge.</p>\
                <p>I also shipped Amazon&rsquo;s own voice-recognition mobile solution and a privacy-preserving federated learning system.</p>",
                image: alexaImage,
                mobileTitle: "Amazon Alexa",
                mobileDescription: "",
                mobileImage: "",
                googlePlayUrl: "https://play.google.com/store/apps/details?id=com.amazon.dee.app",
                appStoreUrl: "https://itunes.apple.com/us/app/amazon-alexa/id944011620"
            },
            photolab: {
                direction: "top",
                title: "Photo Lab",
                badge: "collaboration",
                description: "<p>🏆 App Store Best of 2017&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;🏆 Google Play Best of 2017</p>\
                <p>Full rebrand and customer-experience overhaul I drove while leading the mobile team, working with scientists to ship image style transfer to 120+ million users.</p>",
                image: photolabImage,
                mobileTitle: "Photo Lab",
                mobileDescription: "<p>🏆 App Store Best of 2017</p><p>🏆 Google Play Best of 2017</p>\
                <p>Full rebrand and customer-experience overhaul I drove while leading the mobile team, working with scientists to ship image style transfer to 120+ million users.</p>",
                mobileImage: photolabMobileImage,
                googlePlayUrl: "https://play.google.com/store/apps/details?id=vsin.t16_funny_photo",
                appStoreUrl: "https://itunes.apple.com/us/app/id441457218"
            },
            truckerpath: {
                direction: "ltr",
                title: "Trucker Path",
                description: "<p>The most popular app for truckers in the US.</p>\
                <p>I led mobile development as we grew from a few thousand users to 700,000 - spending as much time talking to truckers about what mattered to them as shipping it.</p>",
                image: truckerpathImage,
                mobileTitle: "Trucker Path",
                mobileDescription: "",
                mobileImage: "",
                googlePlayUrl: "https://play.google.com/store/apps/details?id=com.sixdays.truckerpath",
                appStoreUrl: "https://itunes.apple.com/US/app/id782746890"
            }
        }
    }

    render() {
        return (
            <Fragment>
                <NavigatoinBar />
                <div className={grid.container}>
                    <MainPageHero />
                    <div className={styles["projects-panel"]}>
                        <div className={[fonts["title"], styles["projects-header"]].join(' ')}>
                            $ projects --all
                        </div>
                        <MainPageEtsy/>
                        <MainPagePersonalization/>
                        <MainPageProject project={this.state.projects.alexa}/>
                        <MainPageProject project={this.state.projects.photolab}/>
                        <MainPageProject project={this.state.projects.truckerpath}/>
                    </div>
                    <MainPagePosts />
                </div>
                <Footer />
            </Fragment>
        )
    }
}

export default MainPage;
